import React, {Component} from 'react';
import {Button, Modal, Form, Grid, Header} from 'semantic-ui-react';
import update from 'react-addons-update';

import BranchOfficeData from "../../data/BranchOfficeData";
import resources from "../../data/resources";
import MemberData from "../../data/MemberData";
import Toast from "../extras/Toast";
import localDB from "../../data/localDB";
const C = require("../../constants");

class MemberDialog extends Component {

    constructor() {
        super();

        this.state = {
            open: false,
            user: {
                first_name: '',
                last_name: '',
                password: '',
                email: '',
                rol: '',
                id: null,
                branch_office: {
                    id: '',
                    name: ''
                }
            },
            branch_offices: [],
            branch_office_error: false,
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            rol_error: false,
            index: null,
            store: localDB.get('store'),
            roles: C.USER_TYPES
        };

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRol = this.handleRol.bind(this);
        this.handleBranchOfficeChange = this.handleBranchOfficeChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    updateLabels = (user, index) => {
        this.setState({
            branch_office_error: false,
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            password_error: false,
            rol_error: false,
            user: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                rol: '',
                id: null,
                branch_office: {
                    id: '',
                    name: ''
                }
            }
        });
    };

    componentDidMount() {
        this.getBranchOffices();

        if(this.state.store.category == C.REPAIR_SHOP_CATEGORY){
            let roles = [...this.state.roles, ...C.REPAIR_SHOP_ROLES];
            this.setState({roles});
        }
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices})
    }

    handleBranchOfficeChange = (result) => {
        let branch_office = update(this.state, {
            user: {
                branch_office: {
                    id: {
                        $set: result
                    },
                    name: {
                        $set: result
                    }
                }
            }
        });
        this.setState(branch_office);
        this.setState({branch_office_error: false})
    };

    handleRol = (result) => {
        let rol = update(this.state, {
            user: {
                rol: {
                    $set: result
                }
            }
        });
        this.setState(rol);
        this.setState({rol_error: false})
    };

    handleEmailChange = (event) => {
        let email = update(this.state, {
            user: {
                email: {
                    $set: event.target.value.toLowerCase().trim()
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() === '') {
            this.setState({email_error: true})
        } else {
            if (resources.validators.isValidEmailAddress(event.target.value)) {
                this.setState({email_error: false})
            } else {
                this.setState({email_error: true})
            }
        }
    };

    handlePasswordChange = (event) => {
        let password = update(this.state, {
            user: {
                password: {
                    $set: event.target.value
                }
            }
        });
        this.setState(password);
        if (event.target.value.trim() === '') {
            this.setState({password_error: true})
        } else {
            this.setState({password_error: false});
        }
    };

    handleFirstNameChange = (event) => {
        let first_name = update(this.state, {
            user: {
                first_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(first_name);
        if (event.target.value.trim() === '') {
            this.setState({first_name_error: true})
        } else {
            this.setState({first_name_error: false});
        }
    };

    handleLastNameChange = (event) => {
        let last_name = update(this.state, {
            user: {
                last_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(last_name);
        if (event.target.value.trim() === '') {
            this.setState({last_name_error: true})
        } else {
            this.setState({last_name_error: false});
        }
    };

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.user.first_name === '') {
            this.setState({first_name_error: true});
        } else if (this.state.user.last_name === '') {
            this.setState({last_name_error: true});
        } else if (this.state.user.email === '' || !resources.validators.isValidEmailAddress(this.state.user.email)) {
            this.setState({email_error: true});
        } else if (this.state.user.branch_office.id === '') {
            this.setState({branch_office_error: true});
        } else if (this.state.user.rol === '') {
            this.setState({rol_error: true});
        } else if (this.state.user.password === '') {
            this.setState({password_error: true});
        } else {
            this.setState({disabled_button: true});
            MemberData.create(this.state.user, (res) => {
                if (res.save) {
                    this.refs.toast.show({message: 'Usuario Agregado!', type: 'success'});
                    this.props.callbackAddData(res.user);
                    this.setState({disabled_button: false, open: false});
                } else {
                    this.refs.toast.show({message: res.message, type: 'error'});
                }
                this.setState({disabled_button: false});
            });
        }
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>Nuevo usuario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid divided>
                                    <Grid.Row>
                                        <Grid.Column mobile={16} computer={8}>
                                            <Header as='h3'>Información de la Cuenta</Header>
                                            <Form.Input label='Nombre' placeholder='Nombre'
                                                        value={this.state.user.first_name}
                                                        onChange={this.handleFirstNameChange}
                                                        error={this.state.first_name_error}/>
                                            <Form.Input label='Apellido' placeholder='Apellido'
                                                        value={this.state.user.last_name}
                                                        onChange={this.handleLastNameChange}
                                                        error={this.state.last_name_error}/>
                                            <Form.Input type='email' label='Email' placeholder='Email'
                                                        value={this.state.user.email} onChange={this.handleEmailChange}
                                                        error={this.state.email_error}/>
                                        </Grid.Column>
                                        <Grid.Column mobile={16} computer={8}>
                                            <Header as='h3'>Permisos y Seguridad</Header>
                                            <Form.Select label='Sucursal' options={this.state.branch_offices}
                                                         onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                         value={this.state.user.branch_office.id} placeholder='Sucursal'
                                                         error={this.state.branch_office_error}/>
                                            <Form.Select label='Rol' options={this.state.roles}
                                                         onChange={(e, {value}) => this.handleRol(value)}
                                                         value={this.state.user.rol} placeholder='Rol'
                                                         error={this.state.rol_error}/>
                                            <Form.Input label='Contraseña' type='password' placeholder='Contraseña'
                                                        value={this.state.user.password}
                                                        onChange={this.handlePasswordChange}
                                                        error={this.state.password_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.disabled_button}
                                disabled={this.state.disabled_button} labelPosition='left' onClick={this.handleSubmit}
                                content='Crear usuario'/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

export default MemberDialog;



// WEBPACK FOOTER //
// ./src/components/security/MemberDialog.js